module.exports = __webpack_public_path__ + "media/images/anoreglogo_branco-500755297345d140ca83f51715c0006b.png";